<style lang="stylus">
.delay-inner-pay
    display flex
    background-color white
    font-size 14px
    margin-bottom  10px
    align-items center
    justify-content space-between
    padding 12px 15px
    .delay-title

    .delay-price
        display flex
        align-items center
        .delay-check
          font-size 0
        .delay-numb
          color: #ff5f16

    .delay-check
        margin-left 10px
        img
            width 20px
            height 20px
</style>

<template>
  <div class="delay-inner-pay">
    <div class="delay-title">
      券内扣减
    </div>
    <div class="delay-price">
      <div class="delay-numb">-<decimal-price :price="price" /></div>
      <div class="delay-check">
        <img v-if="isChecked" src="../../../../image/global/check-circle.png" alt="" />
        <img v-else src="../../../../image/global/uncheck-circle.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
import decimalPrice from '../../../components/decimal-price.vue'
export default {
  data() {
    return {}
  },
  methods: {},
  computed: {
    price() {
      console.log()
      if (this.cardData.length > 0) {
        return this.cardData[0].price * this.cardData[0].dueDateMonths
      } else {
        return 0
      }
    },
  },
  components: {
    'decimal-price': decimalPrice,
  },
  props: ['cardData', 'isChecked'],
}
</script>
